<div class="box">
  <div class="box-row header">
    <app-header-bar [title]="'job.admin.title'"></app-header-bar>
  </div>
  <div class="content mt-2 mb-3">
    <div class="row">
      <div class="mt-3 mb-3">
        <label>Filter:</label>
        <p-multiSelect
          [options]="orgs()"
          [(ngModel)]="selected"
          optionLabel="name"
          class="w-100"
          display="chip"
          [showClear]="true"
          placeholder="{{ 'organizations.title' | translate }}"
          (onChange)="loadFiltered()"
        ></p-multiSelect>
      </div>
      <p>{{ 'job.admin.hint' | translate }}</p>
      <app-datatable
        [dataSource]="jobSource"
        [columns]="columns"
        [identifier]="'admin-jobs'"
        [actionNew]="false"
        [customTableActions]="customTableActions"
        (showEvent)="show($event.valueOf())"
      >
        <app-empty-table
          [icon]="'work'"
          [emptyText]="'job.empty_text' | translate"
        >
        </app-empty-table>
      </app-datatable>

      <app-error [error]="error"></app-error>
    </div>
  </div>
</div>

<div
  [class.show]="selectFilterError"
  style="z-index: 9999"
  class="toast align-items-center text-bg-danger border-0 bottom-0 end-0 position-absolute me-2 mb-2"
  role="alert"
  aria-live="assertive"
  aria-atomic="true"
>
  <div class="d-flex">
    <div class="toast-body">
      {{ 'job.admin.select-filter-error' | translate }}
    </div>
  </div>
</div>
